import { exchangeCodeForToken } from './codeExchange';
import { STEP_UP_OAUTH_CONFIG } from './constants';
import { StepUpIframe } from './StepUpIframe';
import type {
  StepUpInteractiveHost,
  StepUpOAuthConfig,
  StepUpTokenProvider,
} from './types';

// Gets a code via StepUpIframe, then exchanges it for a token. `clientId` is required.
export const createStepUpIframeTokenProvider = (
  host: StepUpInteractiveHost,
  config: Partial<StepUpOAuthConfig> = {},
): StepUpTokenProvider => {
  const merged: StepUpOAuthConfig = {
    authorizeUrl: config.authorizeUrl ?? STEP_UP_OAUTH_CONFIG.AUTHORIZE_URL,
    tokenUrl: config.tokenUrl ?? STEP_UP_OAUTH_CONFIG.TOKEN_URL,
    redirectUri: config.redirectUri ?? STEP_UP_OAUTH_CONFIG.REDIRECT_URI,
    clientId: config.clientId ?? STEP_UP_OAUTH_CONFIG.CLIENT_ID,
    scope: config.scope ?? STEP_UP_OAUTH_CONFIG.SCOPE,
  };

  return async (details) => {
    const { code, codeVerifier } = await new StepUpIframe(host, {
      authorizeUrl: merged.authorizeUrl,
      redirectUri: merged.redirectUri,
      clientId: merged.clientId,
      scope: merged.scope,
    }).run(details);
    return exchangeCodeForToken(code, codeVerifier, {
      tokenUrl: merged.tokenUrl,
      redirectUri: merged.redirectUri,
      clientId: merged.clientId,
    });
  };
};
